import { Box, Group, PasswordInput, TextInput, Select, Text, Button } from "@mantine/core";
import { useEffect, useState } from "react";
import { InfoCircle } from "tabler-icons-react";
import { useAuth } from "../../../../providers/AuthProvider";
import { getBankNameList } from "../../../../services/bankingService";
import { ApprovalStatus, BasicInformationProps } from "../../../../types/types";
import { Heading } from "../../heading/heading";


export function BasicInformation(props: BasicInformationProps){
  const authContext = useAuth();
  const [list,setList] = useState<any[]>([]);
  useEffect(() => {
    const method = async () => {
      const bankNameList = await getBankNameList();
     
      const newList : any[] = [];
      if(bankNameList){
        bankNameList.features.forEach( (item: any) => {
          newList.push( {
            label : item.key2,
            value : item.key2
          } )
        })
        setList(newList);
        // list = newList;
      }
      }
      method();
    },[authContext]);
    return(
        <Box
          sx={(theme) => ({
            backgroundColor: theme.colors.gray[0],
            display: "flex",
            justifyContent: "center",
            padding: "16px 0",
            
          })}
        >
          <Box
            sx={(theme) => ({
              width: "65%",
              
            })}
          >
            {(props.successfullySubmitted && props.adminApproval !== ApprovalStatus.PENDING &&  props.adminApproval !== ApprovalStatus.APPROVED) && <Box sx={(theme) => ({
              marginBottom : "16px",
              display: "flex",
              gap: "3%",
              justifyContent: "center",
              alignItems: "center"
              
            })}>
            <Text color="black" size="sm" ml={6}>
            <InfoCircle size={17} strokeWidth={2} color={"black"} />
                    &nbsp;Your account is already created successfully. If you want to do any changes click update👉
            </Text>
            <Button style={{backgroundColor: "#02BBd5"}} onClick={props.testClick}>Update</Button>
            </Box>}
            
            <Heading mainHeading={`Basic Information - ${props.loginid}`} subHeading="Please fill your basic information" />
            <Box
              sx={() => ({
                marginTop: "16px",
              })}
            >
              <TextInput
                placeholder="Enter account holder name"
                label="Name of account holder"
                name="nameOfAccountHolder"
                disabled={props.disableInputs}
                value={props.inputs.nameOfAccountHolder}
                onChange={props.handleChange}
                required
                error={props.formValidation.nameOfAccountHolder.message}
                onKeyDown={() =>
                    props.setFormValidation({
                    ...props.formValidation,
                    nameOfAccountHolder: { message: "", isValidated: true },
                  })
                }
              />
              <Select
              sx={() => ({
                marginTop: "12px",
              })}
                  label="Bank name"
                  placeholder="Search bank name"
                  searchable
                  name="bankName"
                  disabled={props.disableInputs}
                  value={props.inputs.bankName}
                  data={list}
                  error={props.formValidation.bankName.message}
                  onChange={(selected:string)=>{props.handleChangeDropDownBankName(selected,"bankName")}}
                  required
                  onKeyDown={() =>
                    props.setFormValidation({
                      ...props.formValidation,
                      bankName: { message: "", isValidated: true },
                    })
                  }
                />
              <Group
                grow
                sx={() => ({
                  width: "100%",
                  marginTop: "12px",
                  alignItems: "flex-start"
                })}
              >
                <PasswordInput
                  placeholder="Enter WD Bank account number"
                  label="WD Bank account number"
                  name="bankAccountNumber"
                  value={props.inputs.bankAccountNumber}
                  onChange={props.handleChange}
                  disabled={props.disableInputs}
                  required
                  error={props.formValidation.bankAccountNumber.message}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  onKeyDown={() =>
                    props.setFormValidation({
                      ...props.formValidation,
                      bankAccountNumber: { message: "", isValidated: true },
                      confirmBankAccountNumber: { message: "", isValidated: true }
                    })
                  }
                />
                <TextInput
                  placeholder="Enter again your WD Bank account number"
                  label="Confirm WD Bank account number"
                  name="confirmBankAccountNumber"
                  value={props.inputs.confirmBankAccountNumber}
                  autoComplete="off"
                  disabled={props.disableInputs}
                  onChange={props.handleChange}
                  required
                  error={props.formValidation.confirmBankAccountNumber.message}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  onKeyDown={() =>
                    props.setFormValidation({
                      ...props.formValidation,
                      confirmBankAccountNumber: {
                        message: "",
                        isValidated: true,
                      },
                    })
                  }
                />
              </Group>
              <Group
                grow
                sx={() => ({
                  width: "100%",
                  marginTop: "12px",
                  alignItems: "flex-start"
                })}
              >
                <TextInput
                  placeholder="Enter IFSC code"
                  label="IFSC code"
                  name="ifsc"
                  disabled={props.disableInputs}
                  value={props.inputs.ifsc}
                  onChange={(e) => {
                    const inputValue = e.target.value.toUpperCase();
                    props.handleChange({ target: { name: "ifsc", value: inputValue } });
                  }}
                  required
                  error={props.formValidation.ifsc.message}
                  onKeyDown={() =>
                    props.setFormValidation({
                      ...props.formValidation,
                      ifsc: { message: "", isValidated: true },
                    })
                  }
                />
                <TextInput
                  placeholder="123456"
                  label="Pin Code"
                  name="pinCode"
                  value={props.inputs.pinCode}
                  onChange={props.handleChange}
                  required
                  error={props.formValidation.pinCode.message}
                  onKeyDown={() =>
                    props.setFormValidation({
                      ...props.formValidation,
                      pinCode: { message: "", isValidated: true },
                    })
                  }
                />
              </Group>
            </Box>
          </Box>
        </Box>
    )
}